import emptyFunction from "@jnctn/core/utilities/emptyFunction";
import {
  createContext,
  SetStateAction,
  Dispatch,
  useEffect,
  useContext,
} from "react";

type BackAction = string | (() => void);
type BackColor = "white" | "black";

export type Back = { action?: BackAction; color?: BackColor };

const BackContext = createContext<{
  back: Back;
  setBack: Dispatch<SetStateAction<Back>>;
}>({
  back: {},
  setBack: emptyFunction,
});

export function useBack(action?: BackAction, color?: BackColor) {
  const { setBack } = useContext(BackContext);
  useEffect(() => {
    setBack({ action, color });
    return () => {
      setBack({});
    };
  }, [setBack, action, color]);
}

export default BackContext;
